export default __webpack_public_path__ + "static/malaysia-5a54204e50080866a7d6e67a1346b5d3.svg";